export default class LocalizationSettings {
    public url: string;
    constructor(settings: any) {
        this.url = settings.url;
    }
}